<template>
    <div class="menu">
        <h3 class="panel-title">实验分类
          <el-radio-group v-model="radio1" class="rowtab" @change="switc">
              <el-radio-button label="按章节" class="buttontab"></el-radio-button>
              <el-radio-button label="按知识点" class="buttontab"></el-radio-button>
          </el-radio-group>
        </h3>
          <!-- 知识点 -->
          <!-- el-tree方法 -->
        <div class="tree-el">
          <el-tree
              v-loading="loading"
              v-if="ischapter"
              :data="data"
              ref="treez"
              highlight-current
              :props="defaultProps"
              node-key="id"
              accordion
              @node-click="handleOpen">
              <span class="custom-tree-node" slot-scope="{ node }">
                <span :title="node.label">{{ node.label }}</span>
              </span>
          </el-tree>
          <!-- 这里是userSubject为null的时候默认展示全部 -->
          <el-tree
              v-loading="loading"
              v-if="ischapter3"
              :data="data3"
              highlight-current
              :props="defaultProps3"
              node-key="id"
              accordion
              @node-click="handleOpen3">
              <span class="custom-tree-node" slot-scope="{ node }">
                <span :title="node.label">{{ node.label }}</span>
              </span>
          </el-tree>
          <!-- <el-menu class="el-menu-panel"
            default-active="1"
            @open="handleOpen"
            @close="handleClose"
            text-color="#000"
            :unique-opened="true"
            v-if="ischapter"
            > -->
            <!-- el-submenu方法 -->
            <!-- <el-submenu :index="item.id+''" v-for="(item,i) in data" :key="i">
              <template slot="title">
                <span>{{item.chapterName}}</span>
              </template>
              <el-submenu :index="item2.id+''" v-for="(item2,index2) in item.children" :key="index2" class="el-menu-tw">
                <template slot="title">{{item2.chapterName}}</template>
                <el-menu-item :index="item3.id+''" v-for="(item3,index3) in item2.children" :key="index3" @click='handleOpen(item3.id)' class="el-menu-th">{{item3.chapterName}}</el-menu-item>
              </el-submenu>
            </el-submenu> -->
          <!-- </el-menu> -->
            <!-- 章节 -->
          <el-tree
              v-loading="loading"
              v-if="ischapter2"
              :data="data2"
              ref="treej"
              highlight-current
              node-key="id"
              :props="defaultProps2"
              accordion
              @node-click="handleOpen2">
              <span class="custom-tree-node" slot-scope="{ node }">
                <span :title="node.label">{{ node.label }}</span>
              </span>
          </el-tree>
        </div>
          <!-- <el-menu class="el-menu-panel"
              default-active="2"
              @open="handleOpen2"
              @close="handleClose2"
              text-color="#000"
              :unique-opened="true"
              v-if="ischapter2"
            >
            <el-submenu :index="item.id+''" v-for="(item,i) in chapter" :key="i">
              <template slot="title">
                <span>{{item.chapterName}}</span>
              </template>
              <el-submenu :index="item2.id+''" v-for="(item2,index2) in item.children" :key="index2" class="el-menu-tw2">
                <template slot="title">
                  <span style="color:#000;font-weight:400;">{{item2.chapterName}}</span>
                </template>
                <el-submenu :index="item3.id+''" v-for="(item3,index3) in item2.children" :key="index3" class="el-menu-tw3">
                  <template slot="title">{{item3.chapterName}}</template>
                  <el-menu-item :index="item4.id+''" v-for="(item4,index4) in item3.children" :key="index4" @click='handleOpen2(item4.id)' class="el-menu-th2">{{item4.chapterName}}</el-menu-item>
                </el-submenu>
              </el-submenu>
              </el-submenu>
        </el-menu> -->
    </div>
</template>

<script>
import request from '@/utils/request'
import {saveUserSubejct,getUserInfo} from '@/api/user'
import {treesByStatus, chaptertreesByStatus } from '@/api/trees'
  export default {
    data(){
        return{
          getType:0,
          getSubject:0,
          getSubject2:0,
          radio1:'',
          loading:false,
          rescr:false,
          rescr2:false,
          ischapter:false,
          ischapter2:false,
          ischapter3:false,
          data:[{}],
          getinfos:0,
          data2:[{}],
          data3:[{}],
          defaultProps: {
            children: 'children',
            label: 'chapterName'
          },
          defaultProps2: {
            children: 'children',
            label: 'chapterName'
          },
          defaultProps3: {
            children: 'children',
            label: 'chapterName'
          },
          firstMenu:[],
          secMenu:[],
          eduId:'',
          edutreeid:'',
          information:[],
        }
    },
    created(){
        this.getinfo();
    },
    methods: {
      //获取info
      getinfo(){
        getUserInfo().then(res=>{
          if(res.jwtUser.userType==2){
          if(res.userSubjectK == null){
            this.getSubject = 0
           // this.boxEx = true;
          }else{
            this.getSubject = res.userSubjectK.treeId
          }
          if(res.userSubjectC == null){
            this.getSubject2 = 0
           // this.boxEx = true;
          }else{
            this.getSubject2 = res.userSubjectC.treeId
          }
        }else{
          this.getSubject = 0;
          this.getSubject2 = 0;
         
        }

          if(res.userSubject == null){
            this.radio1 = '按知识点';
            this.ischapter = false;
            this.ischapter2 = false;
            this.ischapter3 = true;
            this.getTrees3();
          }else{
            this.getinfos = res
            this.getType = res.userSubject.type
            if(res.userSubject.type == 0){
              this.radio1 = '按知识点';
              this.ischapter = true;
              this.ischapter2 = false;
              this.getTrees();
            }else if(res.userSubject.type == 1){
              this.radio1 = '按章节';
              this.ischapter = false;
              this.ischapter2 = true;
              this.getChapterTrees();
            }
          }
        })
      },
      //知识点和章节切换
      switc(value){
        if(value == "按知识点"){
            this.ischapter = true;
            this.ischapter2 = false;
            this.ischapter3 = false;
            this.rescr = false;
            this.rescr2 = false;
            this.getTrees();
            if(this.getType == 0){
              this.bus.$emit('switcG',0)
            }else{
              this.bus.$emit('switcG',0)
            }
        }else{
            this.ischapter = false;
            this.ischapter2 = true;
            this.ischapter3 = false;
            this.rescr = false;
            this.rescr2 = false;
            this.getChapterTrees();
            if(this.getType == 1){
              this.bus.$emit('switcG2',0)
            }else{
              this.bus.$emit('switcG2',0)
            }
        }
      },
      Rescreening(getinfos){
            this.bus.$emit('rescreeng',this.getinfos)
            this.getTrees();
      },
      Rescreening2(getinfos){
            this.bus.$emit('rescreen2g',this.getinfos)
            this.getChapterTrees();
      },
      //通过知识点获取
      getTrees(){
          this.loading=true,
           treesByStatus(this.getSubject).then(res=>{
            this.data = res.data;
            this.loading=false
          })
      },
      // userSubject 为null的时候展示
      getTrees3(){
          this.loading=true
          treesByStatus(this.getSubject).then(res=>{
            this.data3 = res.data;
            this.loading=false
          })
      },
      //通过章节获取
      getChapterTrees(){
          this.loading=true,
          chaptertreesByStatus(this.getSubject2).then(res=>{
            this.data2 = res.data
            this.loading=false
          })
      },
      // change(index){
      //   this.bus.$emit("ification",item)
      //   this.eduId = index
      // },
      // 实验分类点击事件
      handleOpen(data,index) {
        this.bus.$emit("ificationG",data)
        this.eduId = index
      },
      handleOpen2(data,index) {
        this.bus.$emit("ificationG2",data)
        this.eduId = index
      },
      handleOpen3(data,index) {
        this.bus.$emit("ificationG3",data)
        this.eduId = index
      },
      // 实验分类关闭事件
      handleClose(key, keyPath) {
      },
      handleClose2(key, keyPath) {
      }
    }
  }
</script>

<style scoped>
    @import '../styles/pad.css';
    @import '../styles/treeStyle.css';
  @media screen and (min-width:1025px) and (max-width:1366px){

  }
  @media screen and (min-width:1366px) and (max-width:1440px){
  }
  @media screen and (min-width:1441px) and (max-width:1600px){
  }
  @media screen and (min-width:1601px) and (max-width:1920px){
  }
  @media screen and (min-width:1921px) and (max-width:2048px){
  }
  @media (min-width:2049px){
  }
</style>




// WEBPACK FOOTER //
// src/components/myComponentsM/Menu.vue